<div>
    <img [alt]="currentLogo.alt" [class]="currentLogo.logoCssClass+' img-size' " [src]="currentLogo.url" />
</div>
<a [routerLink]="'/'" [class]="'navbar-brand title '+ currentLogo.labelCssClass">{{ currentLogo.label }}</a>

